import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
    && .image-wrapper {
        img {
            object-fit: contain;
        }
    }
`;

export interface SimilarBlogsWrapProps {
    children?: React.ReactNode;
}

export const SimilarBlogsWrap = ({
    children
}: SimilarBlogsWrapProps & React.CSSProperties): JSX.Element => {
    return <Styled>{children}</Styled>;
};
